import { createStyles, makeStyles, TextField, Theme } from '@material-ui/core';
import React from 'react';
import EditCommonLabel from './EditCommonLabel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    elementPreview: { marginTop: theme.spacing(4), width: '70%' }
  })
);
interface EditNumberProps {
  onUpdateElementLabel: (e: any) => void;
  label: string;
}

const EditNumber = ({ onUpdateElementLabel, label }: EditNumberProps) => {
  const classes = useStyles();
  return (
    <>
      <EditCommonLabel onChange={onUpdateElementLabel} value={label} />
      <TextField
        type="number"
        className={classes.elementPreview}
        disabled
        placeholder="Numerokenttä"
      />
    </>
  );
};
export default EditNumber;
